// Site-wide constants

export const BREAKPOINTS = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
}

export const IMAGE_SIZES = {
  thumb: 400,
  medium: 800,
  full: 1600,
}

export const TRANSITION_DURATION = {
  fast: 150,
  normal: 300,
  slow: 500,
}

export const GALLERY_COLUMNS = {
  mobile: 1,
  tablet: 2,
  desktop: 3,
}

// EmailJS configuration keys (values set in .env.local)
export const EMAILJS_CONFIG = {
  SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID,
  TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
  PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
}
